export const MAIN_CONTENT_WRAPPER = 'main-content-wrapper';
